import { render, staticRenderFns } from "./SelectCustomerTag.vue?vue&type=template&id=5aa17048&"
import script from "./SelectCustomerTag.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports